import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private userActivity: Subject<void> = new Subject<void>();
  private inactivityTimer: any;
  private readonly INACTIVITY_TIMEOUT = 1 * 0 * 1000; // 10 minutes in milliseconds
  private readonly LOGOUT_TIMEOUT =  90 * 60 * 1000; // 90 minutes in milliseconds ?? Change time to 15 due to booking*

  constructor() { }
  // Method to track user activity
  trackUserActivity(): void {
    window.addEventListener('mousemove', this.resetTimer.bind(this));
    window.addEventListener('keypress', this.resetTimer.bind(this));
    this.startTimer();
  }


  // Method to reset the inactivity timer
  private resetTimer(): void {
    clearTimeout(this.inactivityTimer);
    this.startTimer();
  }

  // Method to start the inactivity timer
  private startTimer(): void {
    this.inactivityTimer = setTimeout(() => {
      this.userActivity.next();
    }, this.INACTIVITY_TIMEOUT);
  }

  // Method to listen for inactivity events
  onInactivity(): Observable<void> {
    return this.userActivity.asObservable();
  }

  // Method to get the logout timeout
  getLogoutTimeout(): number {
    return this.LOGOUT_TIMEOUT;
  }
}
